<span
  class="inline-flex min-h-7 min-w-[170px] items-center justify-center rounded-full px-3 py-1 text-sm font-medium"
  [style.background]="backgroundColor"
  [style.color]="textColor"
  [pTooltip]="label"
  tooltipPosition="top"
>
  <span class="block max-w-[170px] truncate text-center">{{ label }}</span>
</span>
